import { useEffect, useState } from "react";

import { AvatarView } from "./styles";

export interface AvatarProps {
  size: number;
  name: string;
  url: string | null;
};

export const Avatar = ({
  size,
  name,
  url,
}: AvatarProps ) => {
  const imageURL = url?.trim() || null;
  const [ imageFailed, setImageFailed ] = useState( false );

  useEffect(() => {
    setImageFailed( false );
  }, [ imageURL ]);

  return (
    <AvatarView
      $size={ size }
    >
      {
        imageURL && !imageFailed
          ? (
            <img
              className="profile-picture"
              src={ imageURL }
              alt={ name }
              onError={() => setImageFailed( true )}
            />
          )
          : null
      }

      <span>{ name.charAt( 0 ).toUpperCase() }</span>
    </AvatarView>
  );
};
